import { generateAnalyticsCb } from '@cld/analytics';

export type AnalyticsAction = 'navigate' | 'show-hide' | 'edit general' | 'edit look and feel' | 'edit resize and crop'
  | 'edit image overlay' | 'edit text overlay' | 'edit export' | 'expand' | 'collapse' | 'copy to clipboard' ;

export interface AnalyticsData {
  eventAction: AnalyticsAction;
  eventLabel: string;
}

export const useAnalytics = () => (eventAction: AnalyticsAction, eventLabel: string) =>
  generateAnalyticsCb({ eventAction, eventLabel })();
